const map = {
	"./bg-login.jpg": 44102,
	"./flags/chinese_flag.svg": 83942,
	"./flags/eu_flag.svg": 57219,
	"./flags/german_flag.svg": 25879,
	"./flags/swiss_flag.svg": 8210,
	"./logo/adjuvo_logo.png": 35218,
	"./menu_icons/Compositions.svg": 49424,
	"./menu_icons/Rawmaterial.svg": 60678,
	"./recycling_calculation.svg": 97168,
	"./shapes/adjuvo_geo_surfaces__Circle.svg": 43027,
	"./shapes/adjuvo_geo_surfaces__Cone.svg": 79414,
	"./shapes/adjuvo_geo_surfaces__Cube.svg": 74224,
	"./shapes/adjuvo_geo_surfaces__Cuboid.svg": 69553,
	"./shapes/adjuvo_geo_surfaces__Cylinder.svg": 24621,
	"./shapes/adjuvo_geo_surfaces__Double_cone.svg": 94310,
	"./shapes/adjuvo_geo_surfaces__Oval.svg": 80895,
	"./shapes/adjuvo_geo_surfaces__Pouch.svg": 97652,
	"./shapes/adjuvo_geo_surfaces__Rectangle.svg": 93146,
	"./shapes/adjuvo_geo_surfaces__Sphere.svg": 69128,
	"./shapes/adjuvo_geo_surfaces__Truncated_Pyramid.svg": 69666
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86190;